import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getNotificationTopics} from 'src/openapi/admin/apis/InternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

export const useNotificationTopics = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getNotificationTopics(),
    ), [apiDispatch]);

    return useReadOnlyDataHook({getDispatchAction, initValue: []});
};
